import { BrowserModule } from "@angular/platform-browser";
import { LOCALE_ID, NgModule } from '@angular/core';
import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { RouterModule } from "@angular/router";
import { HttpClientModule } from "@angular/common/http";
import { ROUTES } from "./app.routes";
import { NgSelectModule } from '@ng-select/ng-select';
import { NgSelectConfig } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DataTablesModule } from "angular-datatables";
import { AppComponent } from "./app.component";
import { NavbarComponent } from "./components/navbar/navbar.component";
import { MenuComponent } from "./components/menu/menu.component";
import { AgmCoreModule } from "@agm/core";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { ModalModule } from "ngx-bootstrap/modal";
import { LoginComponent } from "./pages/login/login.component";
import { TreeviewModule } from "ngx-treeview";
import { NgxPrintModule } from "ngx-print";
import { NgxDropzoneModule } from 'ngx-dropzone';
import { DatePipe } from '@angular/common';
import { QuillModule } from 'ngx-quill';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from "./guards/auth";
import { ApiService } from './services/api.service';
import { HighchartsChartModule } from 'highcharts-angular';
import { FixDropdownOverflowDirectiveDirective } from './directives/fix-dropdown-overflow-directive.directive';
import { ActionMenuComponent } from './components/action-menu/action-menu.component';
import { LibroComponent } from './pages/libro/libro.component';
import { TramiteComponent } from './pages/tramite/tramite.component';
import { ModalRegistroTramiteComponent } from './components/modal-registro-tramite/modal-registro-tramite.component';
import { ModalConformidadComponent } from './components/modal-conformidad/modal-conformidad.component';
import { ModalCustodiaComponent } from './components/modal-custodia/modal-custodia.component';
import { ModalTrazabilidadComponent } from "./components/modal-trazabilidad/modal-trazabilidad.component";
import { SsoLoginComponent } from "./pages/sso-login/sso-login.component";
import { SalonComponent } from "./pages/salon/salon.component";
import { SalonDashboardCardsComponent } from "./components/salon/salon-dashboard-cards/salon-dashboard-cards.component";
import { SalonPosComponent } from "./components/salon/salon-pos/salon-pos.component";
import { SalonManagementComponent } from "./components/salon/salon-management/salon-management.component";
import { SalonReportsComponent } from "./components/salon/salon-reports/salon-reports.component";
import { UppercaseTextDirective } from "./directives/uppercase-text.directive";

registerLocaleData(localeEs);

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    MenuComponent,
    LoginComponent,
    FixDropdownOverflowDirectiveDirective,
    ActionMenuComponent,
    LibroComponent,
    TramiteComponent,
    ModalRegistroTramiteComponent,
    ModalConformidadComponent,
    ModalCustodiaComponent,
    ModalTrazabilidadComponent,
    SsoLoginComponent,
    SalonComponent,
    SalonDashboardCardsComponent,
    SalonPosComponent,
    SalonManagementComponent,
    SalonReportsComponent,
    UppercaseTextDirective
  ],
  imports: [
    BrowserModule,
    HighchartsChartModule,
    DataTablesModule,
    HttpClientModule,
    ReactiveFormsModule,
    QuillModule,
    GooglePlaceModule,
    NgxPrintModule,
    NgxDropzoneModule,
    TreeviewModule.forRoot(),
    ModalModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: "",
      libraries: ["places"],
    }),
    RouterModule.forRoot(ROUTES, { useHash: false, scrollPositionRestoration: 'enabled' }),
    NgSelectModule,
    FormsModule
  ],
  providers: [
    ApiService,
    NgSelectConfig,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: LOCALE_ID,
      useValue: 'es-PE'
    },
  ],
  entryComponents: [
    ActionMenuComponent,
    ModalRegistroTramiteComponent,
    ModalConformidadComponent,
    ModalCustodiaComponent,
    ModalTrazabilidadComponent
  ],
  exports: [ActionMenuComponent],
  bootstrap: [AppComponent],
})
export class AppModule { }
